module.exports = __webpack_public_path__ + "static/img/sanwei-2.9accad0d.png";